import React, { useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { RootState } from '../reducers';
import { fetchAssistantDetails, fetchDocDetails, fetchLinkAssistantsDetails } from '../reduxactions/suprivisoractions/SuprivisorReportsActions';
import { useDispatch, useSelector } from 'react-redux';
import './SuprivisorReports.css'
import { TabView, TabPanel } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import { LoginService } from '../services/LoginService';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { useNavigate } from 'react-router-dom';

interface SharedFileProps {
  item: ItemType; // Replace ItemType with the actual type of item
  furl: any;
  sanitizer: SanitizerType; // Replace SanitizerType with the actual type of sanitizer
}

interface ItemType {
  eventid: number;
  videotype: string;
}

interface SanitizerType { }

export const SuprivisorReports = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [activeIndex, setActiveIndex] = useState(0);
  const [globalFilter, setGlobalFilter] = useState('');
  const stepperRef = useRef(null);


  const dispatch = useDispatch();
  const DoctorReports = useSelector((state: RootState) => state.sreports.docotordetails);
  const AssistantsReports = useSelector((state: RootState) => state.sreports.assiatantdetails);
  const LinkAssistantsReports = useSelector((state: RootState) => state.sreports.linkdetails);

  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchDocDetails(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchDataAsync();
  }, [dispatch]);

  useEffectOnce(() => {
    const fetchDataAsync1 = async () => {
      try {
        await dispatch(fetchAssistantDetails(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchDataAsync1();
  }, [dispatch]);

  useEffectOnce(() => {
    const fetchDataAsync2 = async () => {
      try {
        await dispatch(fetchLinkAssistantsDetails(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchDataAsync2();
  }, [dispatch]);
  const navigate = useNavigate();
  const viewPage = (rowData: any) => {
    const url = `/viewdoctorreports/${rowData.DoctorID}`;
    console.log('rowdata:', rowData.DoctorID)
    navigate(url);
  }
  const viewPage1 = (rowData: any) => {
    const url = `/viewassitantreports/${rowData.AssistantID}`;
    console.log('rowdata:', rowData.AssistantID)
    navigate(url);
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/sup-reports.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="main-content">
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-9">
                <h2>Supervisor Reports</h2>
              </div>

              <div className="col-3">
                <a
                  title="help"
                  onClick={(e) => openWindow(e, IUrl)}
                  style={{

                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                  <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                </a>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2"></div>
              <div className="box box-primary">
                <div className="card">
                  <Stepper ref={stepperRef}>
                    <StepperPanel header="Doctors Details">
                      <p className="m-0">
                        <div>
                          <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div>
                          <div className="card">
                            <DataTable value={DoctorReports} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                              globalFilterFields={['FirstName', 'LastName', 'Email', 'SpecilityName']}>
                              <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                              <Column header="Doctor Name" body={(rowData) => `${rowData.FirstName} ${rowData.LastName}`} />
                              <Column field="SpecilityName" sortable header="Speciality"></Column>
                              <Column field="Email" sortable header="Email"></Column>
                              <Column header="Option" body={(rowData) => (
                                <div className="options-buttons">
                                  <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage(rowData)} />

                                </div>
                              )}></Column>
                            </DataTable>
                          </div>
                        </div>
                      </p>
                    </StepperPanel>

                    <StepperPanel header="Assistants Details">
                      <p className="m-0">
                        <div>
                          <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div>
                          <div className="card">
                            <DataTable value={AssistantsReports} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                              globalFilterFields={['FirstName', 'LastName', 'Email', 'Phone']}>
                              <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                              <Column header="Assistant Name" body={(rowData) => `${rowData.FirstName} ${rowData.LastName}`} />
                              <Column field="Email" sortable header="Email"></Column>
                              <Column field="Phone" sortable header="Phone Number"></Column>
                              <Column header="Option" body={(rowData) => (
                                <div className="options-buttons">
                                  <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage1(rowData)} />

                                </div>
                              )}></Column>
                            </DataTable>
                          </div>
                        </div>
                      </p>
                    </StepperPanel>

                    <StepperPanel header="Link Assistants Details">
                      <p className="m-0">
                        <div>
                          <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div>
                          <div className="card">
                            <DataTable value={LinkAssistantsReports} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                              globalFilterFields={['FirstName', 'LastName', 'dfname', 'dlname']}>
                              <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                              <Column header="Doctor Name" body={(rowData) => `${rowData.dfname} ${rowData.dlname}`} />
                              <Column header="Assistant Name" body={(rowData) => `${rowData.FirstName} ${rowData.LastName}`} />
                            </DataTable>
                          </div>
                        </div>
                      </p>
                    </StepperPanel>
                  </Stepper>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
